import { useTranslation } from "react-i18next";
import HeroSection from "../../components/HeroSection/HeroSection";
import { CONTACT } from "../../constants/contact";
import "./About.css";

function About() {
  const { t } = useTranslation();

  return (
    <main className="about">
      <HeroSection 
        title={t("nav.about")}
        subtitle="Công ty vận chuyển quốc tế Fast Express"
      />

      <section className="about-content">
        <div className="about-container">
          <div className="about-intro">
            <h2>Về Fast Express</h2>
            <p>
              Fast Express là công ty chuyên cung cấp dịch vụ vận chuyển quốc tế hàng đầu, 
              với hơn 10 năm kinh nghiệm trong lĩnh vực logistics. Chúng tôi cam kết mang đến 
              những giải pháp vận chuyển tối ưu, an toàn và hiệu quả cho khách hàng trên toàn thế giới.
            </p>
          </div>

          <div className="about-main">
            <h1 className="about-title">
              CÔNG TY TNHH DỊCH VỤ CHUYỂN PHÁT NHANH QUỐC TẾ FAST EXPRESS
            </h1>

            <div className="about-info">
              <div className="info-group">
                <h3>Thông tin cơ bản</h3>
                <div className="info-item">
                  <span className="info-label">Tên quốc tế:</span>
                  <span className="info-value">FAST EXPRESS INTERNATIONAL</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Tên viết tắt:</span>
                  <span className="info-value">FAST EXPRESS INTERNATIONAL</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Mã số thuế:</span>
                  <span className="info-value">0317442769</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Ngày cấp:</span>
                  <span className="info-value">24/08/2022</span>
                </div>
              </div>

              <div className="info-group">
                <h3>Địa chỉ</h3>
                <div className="info-item">
                  <span className="info-label">Trụ sở chính:</span>
                  <span className="info-value">652/14B Cộng Hoà, Phường Tân Bình, Thành phố Hồ Chí Minh, Việt Nam</span>
                </div>
              </div>

              <div className="info-group">
                <h3>Liên hệ</h3>
                <div className="info-item">
                  <span className="info-label">Người đại diện theo pháp luật:</span>
                  <span className="info-value">HUỲNH LIÊN TÍN</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Email:</span>
                  <span className="info-value">
                    <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Điện thoại:</span>
                  <span className="info-value">
                    <a href={`tel:${CONTACT.phone}`}>{CONTACT.phoneDisplay}</a>
                  </span>
                </div>
              </div>

              <div className="info-group">
                <h3>Thông tin xuất hoá đơn</h3>
                <div className="info-item">
                  <button className="invoice-link">Nhấn vào đây để xem</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
